<template>
  <ss-modal
    v-show="isModalVisible"
    title="Title"
    class="xs"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      Nadanie sygnatury
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <div class="form-group">
        <label>Data wysyłki</label>
        <ss-date
          type="text"
          name="shipment-date"
          v-model="shipment_date"
          @click="lar_errors.clear('shipment_date')"
          :class="{'is-invalid' : lar_errors.has('shipment_date')}"
          placeholder=""/>
        <div
          class="invalid-feedback"
          v-text="lar_errors.get('shipment_date')">
        </div>
      </div>
      <div class="form-group">
        <ss-input
          v-model="shipment_number"
          name="shipment_number"
          label="Nr wysyłki"
          placeholder="Nr wysyłki">
        </ss-input>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled: actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="addSignature"
        :class="{ isLoading: actionInProgress }"
        theme="success"
        class="ml-3">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import SsModal from '@/components/common/SsModal'
import SsDate from '@/components/common/SsDate';
import SsTextarea from '@/components/common/SsTextarea';
import LarErrors from '@/helpers/Errors';

export default {
  name: 'SignatureModal',
  components: {
    SsModal,
    SsDate,
    SsTextarea,
    LarErrors
  },
  props: {
    isModalVisible: {
      type: Boolean,
      default: false
    },
    scheduleId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      actionInProgress: false,
      lar_errors: LarErrors,
      shipment_date: null,
      shipment_number: null
    }
  },
  methods: {
    addSignature () {
      this.actionInProgress = true;
      let _errors = {};
      let _count = 0;

      if (!this.shipment_date) {
        _count++;
        _errors.shipment_date = ['Pole Data wysyłki jest wymagane.'];
      }
      if (!this.shipment_number) {
        _count++;
        _errors.contract_date = ['Pole Nr wysyłki jest wymagane.'];
      }
      if (_count > 0) {
        this.actionInProgress = false;
        this.lar_errors.record(_errors)
      }
      else {
        axios.post('api/clause-signatures/add-signature', {
          schedule_id: this.scheduleId,
          shipment_number: this.shipment_number,
          shipment_date: this.shipment_date
        }).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Wysłano wniosek o nadanie klauzuli wykonalności.',
            showConfirmButton: true,
          }).then(() => {
            this.closeModal(true);
          });
          this.actionInProgress = false;
        }).catch(error => {
          this.actionInProgress = false;
          LarErrors.record(error.response.data.errors)
        })
      }
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('signature-modal-close');
      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
    }
  }
}
</script>
